import { useSession } from '@/stores/session';

/** 产品 / 套装 / 画册三段：桌面视图栏里的三个「页」，手机顶部分段切换（高保真 R1）；按权限只列能进的 */
export function useCatalogSegments() {
  const can = useSession((st) => st.can);
  const items: { to: string; label: string }[] = [];
  if (can('products.read')) items.push({ to: '/products', label: '产品' }, { to: '/bundles', label: '套装' });
  if (can('gallery.read')) items.push({ to: '/gallery', label: '画册' });
  return items;
}
